// insurance-testimonials.js
// Layer 2 — minimal carousel: prev/next scroll buttons that snap one card.

class InsuranceTestimonials extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    this.addEventListener('click', (event) => {
      const target = event.target.closest('[data-action]');
      if (!target) return;
      event.preventDefault();
      const card = this.track.querySelector('.reviews-slider__slide-outer');
      if (!card) return;
      const trackStyle = window.getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const direction = target.dataset.action === 'next' ? 1 : -1;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    });
  }
}

if (!customElements.get('insurance-testimonials')) {
  customElements.define('insurance-testimonials', InsuranceTestimonials);
}
